<template>
  <div class="interview">
    <div class="interview__photo">
      <img src="~/assets/images/heum-people/interview01.png" alt="" />
    </div>
    <div class="interview__content">
      <div class="interview__name">혜움 아카데미 / 장윤정 팀장</div>
      <div class="interview__title">
        “교육을 통한 직원의 역량 강화는 고객의 서비스 만족으로 이어집니다.”
      </div>
      <p class="interview__description">
        혜움은 업계에서 드물게 내부 직원 교육 프로그램을 운영 중입니다. 고객의
        사업을 다루는 직원들의 능력이 곧 혜움이 제공하는 서비스의 질과 직결되기
        때문입니다. 고객과 함께 만족할 수 있는 '혜움형 인재'를 만들어내기 위해
        노력하고 있습니다.
      </p>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.interview {
  @include clearfix;
  max-width: 780px;
  margin: 0 auto;
  padding: 4rem 1rem;

  @include av-mq(lap-and-up) {
    padding: 5rem 1rem;
  }

  &__photo {
    margin-bottom: 1.5rem;
    text-align: center;

    @include av-mq(lap-and-up) {
      float: left;
      margin: 0 3.5rem 2.5rem 0;
    }

    img {
      max-width: 200px;
    }
  }

  &__name {
    margin-bottom: 1rem;
    font-size: 16px;
    color: #1f75e8;
  }

  &__title {
    margin-bottom: 1rem;
    font-size: 26px;
    line-height: 1.48;
    color: #323438;
    word-break: keep-all;

    @include av-mq(lap-and-up) {
      font-size: 32px;
    }
  }

  &__description {
    font-size: 16px;
    line-height: 1.48;
    color: #323438;
    word-break: keep-all;

    @include av-mq(lap-and-up) {
      font-size: 18px;
    }
  }
}
</style>
